module.exports = __webpack_public_path__ + "img/头像.70343648.jpg";